<div *ngIf="isLoading" class="loading-modal-spinner">
    <h2 class="callback-title">Completing Authorization...</h2>
    <owc-progress-spinner />
</div>

<div class="oauth2-callback-container">
    <!-- Error state -->
    <div *ngIf="hasError" class="callback-card callback-card--error">
        <div class="error-icon">&#10007;</div>
        <h2 class="callback-title callback-title--error">Authorization failed</h2>
        <p class="callback-redirect-notice">Redirecting to login&hellip;</p>
    </div>
</div>
